<template lang="pug">
.container
  .card.marginTop.cardGeral
    .card-body
      div(class="card-header").titulo Pesquisar
      .searchPanel
          form(@submit.prevent="$emit('search', searchObject.simpleFieldValue)")
             .panel
              el-row.boxLabel(:gutter="20")
                el-col(:lg="6", :md="12", :sm="24")
                  p.label Processo:
                  el-input(
                    v-model="filtro.numeroProcesso"
                  )
                el-col(:lg="6", :md="12", :sm="24")
                  p.label Data de criação:
                  el-date-picker.full-width.input.date(
                    v-bind="$attrs",
                    type="daterange",
                    start-placeholder="Período inicial",
                    end-placeholder="Período Final",
                    format="dd/MM/yyyy",
                    v-model="filtro.dataCriacao"
                    name='data',
                  )
                el-col.marginTop.toRight
                  el-button(
                    v-if="botaoLimpar"
                    type="text"
                    @click="handleLimpar()"
                  ) Limpar
                  el-button(
                    type="primary"
                    @click="pesquisar()"
                  ).marginLeft
                    i.fal.fa-search
                    |&emsp;Pesquisar
</template>

<script>

export default {
  props: {
    botaoLimpar: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      tipos: [],
      assuntos: [],
      status: [],
      filtro: {
        numeroProcesso: null,
        dataCriacao: null
      }
    }
  },

  methods: {
    pesquisar () {
      this.$emit('search', this.filtro)
    },
    handleLimpar () {
      this.$emit('limpar', this.filtro)
    }
  },

  beforeMount () {
    this.pesquisar()
  }

}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/_variables.scss";

  .searchPanel {
    display: flex;
    flex-direction: column;
    text-align: left;

    .full-width {
      width: 100%;
    }
  }
  .span{
    margin: 5px 10px !important;
  }
  .flex{
    display: flex;
    align-items: flex-end;
  }
  .label-option {
    font-family: Arial, Helvetica, sans-serif;
  }
  .marginTop {
    margin-top: 13px;
  }
  .label {
    font-size: 13px;
  }
  .toRight {
    display: flex;
    justify-content: flex-end;
  }
  .marginLeft {
    margin-left: 13px;
  }
  .titulo {
    font-size: 1.5rem;
    padding: 0 0 23px 0;
  }

  @media (max-width: 780px) {
    .boxLabel {
      display: flex;
      flex-direction: column;
    }

    .searchPanel .full-width {
      width: 230px;
    }

    .marginLeft {
      padding-bottom: 20px;
      padding-top: 20px;
    }

    .flex {
      flex-direction: column;
      align-items: start;
    }

    .cardGeral {
        position: relative;
        top: 95px;
        right: 45%;
    }

    .searchPanel {
      height: 680px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/SearchConflitos.vue